module.exports = __webpack_public_path__ + "media/images/ico-select-acbe50aede945f5683b0c96567518272.svg";